/**
 * Model fit badge — click the pill to reveal the model's height / size.
 */

export class ModelFit extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  /**
   * @param {MouseEvent} event
   */
  onClick = (event) => {
    if (!event.target.closest('.model-fit__trigger')) return;

    const open = !this.classList.contains('is-active');

    this.classList.toggle('is-active', open);
    this.querySelector('.model-fit__trigger')?.setAttribute('aria-expanded', String(open));
  };
}

if (!customElements.get('model-fit')) {
  customElements.define('model-fit', ModelFit);
}
